import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Spinner,
} from "reactstrap"
import classnames from "classnames"
import { Link, useParams } from "react-router-dom"
import LoadingButton from "../../../components/Common/LoadingButton"
import { UFInput } from "../../../components/Common/Fields/Input"
import { useForm, FormProvider } from "react-hook-form"
import { Form, FormGroup, Label } from "reactstrap"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import closeIcon from "../../../assets/icons/close.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { fetchProduct } from "../../../services/Inventory/inventory"
import EducationalDegree from "../../../components/Common/chooseFields/eduDegree"
import EducationalDepartment from "../../../components/Common/chooseFields/eduDepartment"
import SingleFileInput from "../../../components/Common/Fields/singleFileInput"
import {
  fetchEmployeeEducation,
  postHrmsEmployeeEducation,
} from "../../../services/Hrms/hrms"

const schema = yup.object().shape({
  degree_id: yup.mixed().required("Degree is Required"),
  degree_department_id: yup.mixed().required("Department is Required"),
})
const Edit = ({ loading, onUpdate, close, getEditValue }) => {
  const { id } = useParams()
  const [certificateSts, setCertificateSts] = useState()
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      degree_id: null,
      degree_department_id: null,
      certificates: null,
    },
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (getEditValue?.data?.id) {
      setCertificateSts(getEditValue?.data?.certificates)
      reset({
        ...getEditValue?.data,
        basicdetails_id: id,
        degree_id: {
          label: getEditValue?.data?.degree?.degree,
          value: getEditValue?.data?.degree?.id,
        },
        degree_department_id: {
          label: getEditValue?.data?.degree_department?.name,
          value: getEditValue?.data?.degree_department?.id,
        },
      })
    }
  }, [getEditValue])

  const handleRegistration = async data => {
    try {
      setIsLoading(true)

      const updateDepartment = await postHrmsEmployeeEducation({
        ...data,
        basicdetails_id: id,
        degree_id: data?.degree_id?.value,
        degree_department_id: data?.degree_department_id?.value,
        ...(data?.certificates?.[0] instanceof File
          ? {
              certificates: data?.certificates?.[0],
            }
          : {
              certificates: "",
            }),
      })
      onUpdate()
      close()
      toastSuccess(updateDepartment?.message)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  const handleChange = (name, file) => {
    setValue(name, file)
    setCertificateSts("")
  }

  return (
    <>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5 className="editmodelheadtitle">{getEditValue?.data?.id ? "Edit Education" : "Add Education"}</h5>
          <img
            src={closeIcon}
            alt=""
            onClick={close}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="md"
          />
        </div>
      ) : (
        <>
          <ModalBody>
            <FormProvider {...methods}>
              <Form id={`ev-form`} onSubmit={handleSubmit(handleRegistration)}>
                <Row>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Degree<span className="mandatory">*</span>
                      </Label>
                      <EducationalDegree
                        control={control}
                        name={"degree_id"}
                        placeholder="Select the Degree"
                        invalid={!!errors.degree_id}
                        // disabled={getEditValue?.data?.id}
                      />
                      <FormFeedback invalid>
                        {errors.degree_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Department<span className="mandatory">*</span>
                      </Label>
                      <EducationalDepartment
                        control={control}
                        name={"degree_department_id"}
                        invalid={!!errors.degree_department_id}
                        placeholder="Select the Department"
                      />
                      <FormFeedback invalid>
                        {errors.degree_department_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Certificate<span className="mandatory">*</span>
                      </Label>
                      <SingleFileInput
                        control={control}
                        accept=".png,.jpg,.jpeg,.svg,.pdf"
                        name={`certificates`}
                        label="Upload File"
                        onlyIcon={true}
                        tooltip="Cerificate Upload"
                        handleChange={handleChange}
                        downloadPath={certificateSts}
                      />
                      <FormFeedback invalid>
                        {errors.certificates?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              form={`ev-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {getEditValue?.data?.id ? "Update" : "Save"}
            </LoadingButton>
          </ModalFooter>
        </>
      )}
    </>
  )
}

const EditEducation = ({
  buttonLabel,
  className,
  editValue,
  modelOpen,
  ...props
}) => {
  const [modal, setModal] = useState(false)
  const [getEditValue, setGetEditValue] = useState("")
  const toggle = () => setModal(!modal)
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchEmployeeEducation(editValue?.id)
      if (response?.status) {
        setGetEditValue(response)
      }
    }
    if (editValue?.id) {
      fetchData()
    }
  }, [editValue?.id])

  useEffect(() => {
    if (modelOpen) {
      setModal(true)
    }
  }, [modelOpen])
  return (
    <>
      <Link to="#" className={className} onClick={toggle}>
        {buttonLabel}
      </Link>
      <Modal isOpen={modal} toggle={toggle} size="md" backdrop={"static"}>
        <Edit
          close={() => {
            setModal(false)
            setGetEditValue("")
            props?.onReset()
          }}
          getEditValue={getEditValue}
          {...props}
        />
      </Modal>
    </>
  )
}

export default EditEducation
